// extracted by mini-css-extract-plugin
export default {"project":"Project_project__lRxAC","body":"Project_body__E4RiR","fadeIn":"Project_fadeIn__mkH9K","hoverLineLink":"Project_hoverLineLink__b-EbW"};